<template>
  <div class="mb-2">
    <label :for="id" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{ label }}</label>
    <select
      :id="id"
      :value="modelValue"
      @change="updateValue($event)"
      :class="[selectClasses, 'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed']"
      :required="required"
      :multiple="multiple"
      :disabled="disabled"
    >
      <option v-if="placeholder && !multiple" disabled value="">{{ placeholder }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [String, Array],
      default: () => [],
    },
    label: String,
    id: String,
    selectClasses: String,
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: String,
    required: Boolean,
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    updateValue(event) {
      const selectedOptions = Array.from(event.target.selectedOptions).map(option => option.value);
      this.$emit('update:modelValue', this.multiple ? selectedOptions : selectedOptions[0]);
    }
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>
